module.exports = __webpack_public_path__ + "img/background.49b11cb5.png";